import React from "react";
import { NearbyGamesSection } from "../components/NearbyGamesSection";

export default function MaintenancePage() {
  return (
    <div
      className="min-h-screen bg-[#0a0a0a] text-white flex flex-col items-center justify-center px-6 relative overflow-hidden"
      data-testid="maintenance-page"
    >
      {/* Ambient glow */}
      <div
        className="pointer-events-none absolute -top-1/3 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full opacity-25 blur-[120px]"
        style={{ background: "radial-gradient(circle, #FF6B35 0%, transparent 70%)" }}
      />
      <div
        className="pointer-events-none absolute bottom-[-20%] right-[-10%] w-[500px] h-[500px] rounded-full opacity-10 blur-[120px]"
        style={{ background: "radial-gradient(circle, #FF6B35 0%, transparent 70%)" }}
      />

      <div className="relative z-10 max-w-2xl w-full text-center flex flex-col items-center">
        <img
          src="/logo-complet-arcanapp.png"
          alt="Arcanapp"
          className="h-12 sm:h-14 mb-10 animate-[fadeIn_0.8s_ease-out]"
          onError={(e) => { e.target.style.display = "none"; }}
        />

        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight">
          Retrouvez les tournois et les salles de jeux{" "}
          <span className="text-[#FF6B35]">autour de chez vous</span>
        </h1>

        <p className="mt-6 text-lg text-[#B0B0B0]">
          Connectez-vous avec d'autres joueurs.
        </p>

        <div className="mt-12 inline-flex items-center gap-3 rounded-full border border-[#333] bg-[#141414]/80 backdrop-blur px-5 py-2.5">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FF6B35] opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#FF6B35]" />
          </span>
          <span className="text-sm font-medium text-[#E0E0E0]">
            Le site web arrive très prochainement.
          </span>
        </div>

        {/* Parties près de chez moi (recherche réservée aux connectés) */}
        <div className="mt-12 w-full text-left">
          <NearbyGamesSection isAuthenticated={false} />
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
